import { render, staticRenderFns } from "./preformatted-modal-diagnosis.vue?vue&type=template&id=1d36a010&scoped=true&"
import script from "./preformatted-modal-diagnosis.ts?vue&type=script&lang=ts&"
export * from "./preformatted-modal-diagnosis.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-modal-diagnosis.scss?vue&type=style&index=0&id=1d36a010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d36a010",
  null
  
)

export default component.exports